/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Fedorov Maxim
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.0.1
 */

import forEach from 'lodash/forEach';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { SortEnum } from '../../../../../components/Table/components/Filters/Filter';
import { API_HOSTNAME, FILTER_AND_SORT, SUBSCRIBER_MOBILE, WIDGET_API, WIDGET_SUBSCRIBER_MOBILE } from '../../../../../modules/app/Api';
import { appHistoryPush } from '../../../../../modules/app/appHistory';
import { makeSelectLocalStorageSelectedAccount } from '../../../../../modules/storage/storageSelectors';
import { RoutePath } from '../../../../../routes/constants/routesConstants';
import { filterToJson, IFilters } from '../../../../../sagas/filterToJson';
import { requestSaga } from '../../../../../sagas/requestSaga';
import { widgetSubscriberMobileFail, widgetSubscriberMobileSuccess } from './widgetSubscriberMobileActions';
import { TWidgetSubscribersMobileRedirectAction } from './widgetSubscriberMobileTypes';

export function* widgetSubscriberMobileLoadDataSaga(): SagaIterator {
    try {
        const selectedAccount = (yield select(makeSelectLocalStorageSelectedAccount())).id;
        const URL = `${API_HOSTNAME}${WIDGET_API}${WIDGET_SUBSCRIBER_MOBILE}/${selectedAccount}`;
        const response = yield call(requestSaga, URL, 'GET');

        // Parse subs
        forEach(['activeSubs', 'blockedSubs', 'noSimCardSubs'], (name: string) => {
            response[name] = {
                count: response[name]?.count || 0,
                names: response[name]?.names || [],
            }
        });

        yield put(widgetSubscriberMobileSuccess(response));
    } catch (e: any) {
        yield put(widgetSubscriberMobileFail(e));
    }
}

export function* widgetSubscriberMobileRedirectSaga(action: TWidgetSubscribersMobileRedirectAction): SagaIterator {
    try {
        const filterAndSort: IFilters = {
            filter: {},
            sort: {},
        };
        if (action.payload !== '') {
            filterAndSort.sort = {
                direction: SortEnum.ascending,
                property: action.payload,
            };
            const json = filterToJson(filterAndSort);
            yield call(requestSaga, API_HOSTNAME + SUBSCRIBER_MOBILE + FILTER_AND_SORT, 'POST', json);
            appHistoryPush(RoutePath.subscriberMobile);
        }
        const json = filterToJson(filterAndSort);
        yield call(requestSaga, API_HOSTNAME + SUBSCRIBER_MOBILE + FILTER_AND_SORT, 'POST', json);
        appHistoryPush(RoutePath.subscriberMobile);
    } catch (e) {
        console.log(e);
    }

}
